
import { selectWarehouse, updateWarehouseAlarmState } from 'containers/Warehouses/warehousesSlice'
import useTranslation from 'hooks/useTranslation'
import Switch from 'components/inputs/Switch'
import { useParams } from 'react-router-dom'
import { useReduxDispatch, useReduxSelector } from 'store'
import React, { useState } from 'react'
import { POST } from 'rest/request'
import * as urls from 'rest/urls'

const Alarm: React.FC = () => {
  const [isLoading, setLoading] = useState(false)
  const { id } = useParams<warehouse.PageParams>()
  const { hasAlarmZone, alarmState, actions } = useReduxSelector(state => selectWarehouse(state, id))
  const action = actions?.warehouse?.[alarmState?.zone === 'armed' ? 'disarm' : 'arm']

  const dispatch = useReduxDispatch()
  const { t } = useTranslation('warehouse')
  const changeState = async () => {
    if (isLoading || !action) return
    try {
      if (action.type === 'request' && action.method === 'POST') {
        setLoading(true)
        const body = action.payload
        const response = await POST(`${urls.api}${action.url}`, { body })
        if (response?.result === 'ok') {
          setLoading(false)
          dispatch(updateWarehouseAlarmState({ id, alarmState: { zone: alarmState?.zone === 'armed' ? 'disarmed' : 'armed' } }))

        } else {
          throw new Error('Wrong response')
        }

      } else {
        throw new Error('No supported action')
      }
    } catch (error) {
      setLoading(false)
      console.error(error)
    }
  }

  return (
    <div className='menu__section menu__manage'>
      <p>{t('security')}</p>
      <div className='menu__access'>
        <hr />
        <div
          className='access__item'
          onClick={() => {
          }}>
          <div className='center'>
            <i className='icon icon--alarm' />
          </div>
          <div className='access__desc'>
            <div className='--secFont'>{t('alarm')}</div>
            <div>{t('armed')}</div>
          </div>
          <div className='center'>
            <Switch
              name='alarm'
              disabled={!hasAlarmZone || isLoading || !action}
              checked={alarmState?.zone === 'armed'}
              changeHandler={() => {
                changeState()
              }}
            />
          </div>
        </div>
        <hr />
      </div>
    </div>
  )
}

export default Alarm